/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_Linux_Step1Inputs */

const en_gc_resources_download_linux_step1 = /** @type {(inputs: Gc_Resources_Download_Linux_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download the .AppImage file into a folder you can find again.`)
};

const zh_gc_resources_download_linux_step1 = /** @type {(inputs: Gc_Resources_Download_Linux_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将 .AppImage 下载到方便找到的文件夹。`)
};

/**
* | output |
* | --- |
* | "Download the .AppImage file into a folder you can find again." |
*
* @param {Gc_Resources_Download_Linux_Step1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_linux_step1 = /** @type {((inputs?: Gc_Resources_Download_Linux_Step1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_Linux_Step1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_linux_step1(inputs)
	return zh_gc_resources_download_linux_step1(inputs)
});
export { gc_resources_download_linux_step1 as "gc.resources.download.linux.step1" }